import { cn } from "@/shared/lib/utils"
import { Maskot } from "./maskot"
import { adalahSlotMaskot, cariSlot, type KunciSlot } from "@/modules/media/domain/slot"

export function IlustrasiBawaan({ kunci, className }: { kunci: KunciSlot; className?: string }) {
  if (adalahSlotMaskot(kunci)) {
    return (
      <div aria-hidden="true" className={cn("relative mx-auto aspect-[252/190] w-full max-w-[18rem]", className)}>
        <Maskot kunci={kunci} />
      </div>
    )
  }

  const slot = cariSlot(kunci)
  if (!slot?.bawaanUrl) return null
  return <img src={slot.bawaanUrl} alt="" aria-hidden="true" width={slot.lebar} height={slot.tinggi} decoding="async" className={cn("mx-auto h-auto w-full max-w-[18rem] object-contain", className)} />
}
